import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution, track } from "@/lib/analytics";

export const AnalyticsRouteTracker = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    captureAttribution();
  }, [search]);

  useEffect(() => {
    track("$pageview", { path: pathname, url: window.location.href });
  }, [pathname]);

  return null;
};

export default AnalyticsRouteTracker;
